import { Reveal, Label } from "./Reveal";
import { Star } from "lucide-react";

const reviews = [
  {
    name: "Project Frugal",
    meta: "5 reviews · 9 photos",
    when: "4 months ago",
    text: "Ricky and Jahrome gave us a very cost effective and reasonable quote to replace and fix up some weatherboards, replace a bedroom ceiling and fix a hole in our carport. Once we accepted, the communication was excellent and the work done was superb.",
    span: "lg:col-span-7",
  },
  {
    name: "Josie Ratana",
    meta: "6 reviews · 2 photos",
    when: "7 months ago",
    text: "Highly recommend — quick to respond for a quote to fix a broken fence, great communication throughout, and the work was done within a short timeframe. Ricky and his team did a really great job.",
    span: "lg:col-span-5",
  },
  {
    name: "Dayna Wright",
    meta: "2 reviews",
    when: "9 months ago",
    text: "Great communication from Ricky, never any stress. He always keeps me updated if the weather isn't on his side to mow my lawns. Love coming home and seeing my lawns are done — and the price is great too.",
    span: "lg:col-span-5",
  },
];

const Card = ({ r }) => (
  <Reveal className={r.span}>
    <div
      data-testid="review-card"
      className="relative h-full bg-bone-200 border border-forest-ink/10 rounded-sm p-8 md:p-10 overflow-hidden group hover:border-forest/40 transition-colors duration-500"
    >
      <span className="pointer-events-none absolute -top-8 right-4 font-serif text-[9rem] leading-none text-forest/10 select-none">
        &rdquo;
      </span>
      <div className="flex gap-0.5 mb-5">
        {[...Array(5)].map((_, i) => (
          <Star key={i} size={15} className="fill-clay text-clay" />
        ))}
      </div>
      <p className="relative text-forest-ink text-lg md:text-xl leading-relaxed font-serif italic">
        {r.text}
      </p>
      <div className="mt-8 pt-6 border-t border-forest-ink/10 flex items-center justify-between">
        <div>
          <div className="text-forest-ink font-medium">{r.name}</div>
          <div className="text-forest-muted text-xs tracking-wide">{r.meta}</div>
        </div>
        <span className="text-forest-muted text-xs">{r.when}</span>
      </div>
    </div>
  </Reveal>
);

export default function Reviews() {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="bg-bone-300/40 border-y border-forest-ink/10"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-end mb-12">
          <Reveal className="lg:col-span-8">
            <Label>Reviews</Label>
            <h2 className="mt-4 font-serif text-5xl md:text-7xl tracking-tighter text-forest-ink leading-[0.9]">
              A perfect <span className="italic text-forest">5.0</span>, and earned.
            </h2>
          </Reveal>
          <Reveal className="lg:col-span-4" delay={0.1}>
            <div className="flex lg:justify-end items-center gap-4">
              <span className="font-serif text-7xl text-forest-ink leading-none">5.0</span>
              <div>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={16} className="fill-clay text-clay" />
                  ))}
                </div>
                <div className="text-forest-muted text-sm mt-1">Based on 5 reviews</div>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {reviews.map((r) => (
            <Card key={r.name} r={r} />
          ))}
          <Reveal className="lg:col-span-7" delay={0.05}>
            <div className="h-full bg-forest text-bone rounded-sm p-8 md:p-10 flex flex-col justify-between">
              <p className="font-serif text-3xl md:text-4xl leading-tight tracking-tight">
                Quick to quote. Excellent communication. Tidy, honest work — every time.
              </p>
              <div className="mt-8 flex flex-wrap gap-x-8 gap-y-2 text-bone/70 text-xs tracking-[0.25em] uppercase">
                <span>Work quality</span>
                <span>Communication</span>
                <span>Fair quotes</span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
